import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import TipsterLogo from './TipsterLogo';
import { useData } from '../context/DataContext';
import { recentForm, summarize, cheapestPlan } from '../lib/tips';

const LEGS = { double: ['Selection 01', 'Selection 02'], single: ['Selection'] };

export default function TipsterTriptych() {
  const { tipsters, entriesFor } = useData();
  return (
    <div className="relative grid gap-3" data-testid="tipster-triptych">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-royal/30 blur-3xl pointer-events-none" />
      {tipsters.map((t, i) => {
        const list = entriesFor(t.id);
        const s = summarize(list);
        const form = recentForm(list, 8);
        const legs = LEGS[t.format] || LEGS.single;
        return (
          <Link
            to={`/tipsters/${t.id}`}
            key={t.id}
            className={`group relative rounded-[22px] bg-navy text-white p-5 border border-white/10 grain overflow-hidden card-lift ${i === 1 ? 'lg:translate-x-6' : ''}`}
            data-testid={`triptych-${t.id}`}
          >
            <div className="relative flex items-center gap-4">
              <TipsterLogo tipster={t} className="w-12 h-12" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <div className="font-display font-bold text-base">{t.name}</div>
                  <span className="hidden sm:inline-flex px-2 py-0.5 rounded-full text-[10px] font-mono font-bold tracking-wider uppercase" style={{ background: `${t.accent}26`, color: t.accent }}>{t.formatLabel}</span>
                </div>
                <div className="mt-1.5 flex items-center gap-2">
                  {legs.map(l => (
                    <span key={l} className="h-1.5 rounded-full flex-1 max-w-[72px]" style={{ background: t.accent }} />
                  ))}
                  <span className="text-[10px] font-mono text-white/50 ml-1">{legs.length === 2 ? '2 legs · 1 ticket' : '1 leg'}</span>
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="text-[10px] font-mono uppercase tracking-wider text-white/50">from</div>
                <div className="font-mono text-lg font-bold">€{cheapestPlan(t).price}</div>
              </div>
            </div>
            <div className="relative mt-4 flex items-center justify-between gap-3">
              <div className="flex items-center gap-1" title="Last results">
                {form.map((r, j) => <span key={j} className={`w-2 h-2 rounded-full ${r === 'WIN' ? 'bg-win' : 'bg-loss'}`} />)}
              </div>
              <div className="text-[11px] font-mono text-white/60">{s.won}W · {s.lost}L · avg {s.avgOdds}</div>
              <ArrowRight className="w-4 h-4 text-white/40 group-hover:text-white group-hover:translate-x-0.5 transition-all" />
            </div>
          </Link>
        );
      })}
    </div>
  );
}
